import { render, staticRenderFns } from "./EventsAgendaWidget.vue?vue&type=template&id=622296f5&scoped=true"
import script from "./EventsAgendaWidget.vue?vue&type=script&lang=js"
export * from "./EventsAgendaWidget.vue?vue&type=script&lang=js"
import style0 from "./EventsAgendaWidget.vue?vue&type=style&index=0&id=622296f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622296f5",
  null
  
)

export default component.exports